import { useSelector } from 'react-redux'

import { selectedDashboardFilterTabSelector } from '../selectors'

export function useSelectedDashboardFilterTab() {
  return useSelector(selectedDashboardFilterTabSelector)
}
